<template>
  <full-screen-slide
    v-bind:background-image-src="image.image"
  >
    <transition appear name="main-logo-full">
      <img
        class="main-logo-full"
        src="/static/images/logo/logo.svg"
        alt="Логотип ювелирной фирмы «Стиль»"
        width="220"
        height="95"
      >
    </transition>
    <transition appear name="arrow-down">
      <footer
        class="arrow-down-footer"
        v-on:click="$emit('scroll-to-second-slide')"
      >
        <svg-sprite-icon
          class="arrow-down"
          v-bind:src="'arrow-down'"
        ></svg-sprite-icon>
      </footer>
    </transition>
  </full-screen-slide>
</template>

<script>
import FullScreenSlide from './utils/FullScreenSlide'
import SvgSpriteIcon from '../utils/SvgSpriteIcon'
import smoothscroll from 'smoothscroll-polyfill'
// kick off the polyfill
smoothscroll.polyfill()

export default {
  name: 'MainSlideFirst',
  props: ['image'],
  components: { FullScreenSlide, SvgSpriteIcon },
  data: function () {
    return {}
  }
}
</script>

<style scoped lang="scss">
  .main-logo-full {
    display: block;
    position: relative;
    transform: translateY(-50%);
    @include media(">desktop") { top: -3%; };
    @include media("<=desktop") {
      @media (max-height: 480px) { top: 3%; }
      @media (min-height: 481px) { top: -13%; }
    };

    filter: drop-shadow(5px 10px 5px #000);
    opacity: 0.9;
    visibility: visible;
    width: 300px;
    height: auto;
    max-width: 100%;
    @media (max-height: 480px) {
      width: 260px;
    }
    @media only print {
      position: static;
      filter: invert(100%);
      transform: none;
    }
  }
  .main-logo-full-enter {
    visibility: hidden;
    opacity: 0;
    margin-top: -50px;
  }
  .main-logo-full-enter-active {
    transition: margin 1s, opacity 1.5s;
  }
  .arrow-down-footer {
    position: absolute;
    bottom: 20%;
    left: 50%;
    transform: translate(-50%, 80%);
    @media only print {
      display: none;
    }
  }
  .arrow-down {
    cursor: pointer;
    filter: drop-shadow(0px 7px 5px #000);
    display: inline-block;
    width: 64px;
    height: 36px;
    opacity: 1;
  }
  .arrow-down-enter {
    visibility: hidden;
    opacity: 0;
    margin-bottom: -50px;
  }
  .arrow-down-enter-active {
    transition: margin 1s, opacity 1.5s;
    transition-delay: 0.5s;
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/MainSlideFirst.vue